var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "m17.6 15.73-3.09-3.057a6.826 6.826 0 1 0-5.674 3.036 6.75 6.75 0 0 0 3.789-1.158l3.096 3.096a1.33 1.33 0 0 0 1.878 0 1.33 1.33 0 0 0 0-1.918zM8.835 4.015A4.828 4.828 0 1 1 4.007 8.85a4.834 4.834 0 0 1 4.828-4.835"
  })));
};
export { SvgSearchIcon as ReactComponent };